<template>
    <v-switch
            v-model="isPublic"
            :label="$t('field.public')"
            @change="changed()"
    ></v-switch>
</template>

<script>
    export default {
        name: "PublicInput",
        props: {
            value: {
                required: true,
                type: Boolean,
            }
        },
        data () {
            return {
                isPublic: this.value,
            }
        },
        methods: {
            changed () {
                this.$emit('input', this.isPublic);
            }
        },
        watch: {
            value () {
                this.isPublic = this.value;
            },
        },
    }
</script>

<style scoped>

</style>
